import React from "react"
// import { useAlert } from "hooks/useAlert"
import { useTranslation } from "react-i18next"
import FormElement from "components/Form/FormElement"
import { refusedPartnerStatusList } from "utils/constants"

const defaultFormFields = {
    "raison_refus": "",
    "explication_refus": ""
}

const statusFilter = [
    { value: -1, label: "Tous", id: "all" },
    ...refusedPartnerStatusList
]

export const RefusedPartnerForm = ({ updateForm }) => {
    const [formFields, setFormFields] = React.useState(defaultFormFields)

    const [, setErrors] = React.useState([])
    const [showLocalErrors, ] = React.useState(false)

    // const { alert } = useAlert()
    const { t } = useTranslation()

    const handleInputChange = React.useCallback(
        (event) => {
            const target = event.target
            const value = target.type === "checkbox" ? target.checked : target.value
            const name = target.name
            setFormFields(s => ({
                ...s,
                [name]: value
            }))
        }, []
    )

    React.useEffect(() => {
        updateForm(formFields)
    }, [formFields]) // eslint-disable-line

    const handleValidation = React.useCallback((name, errs) => {
        setErrors((s) => {
            const cleanErrors = [...s.filter((e) => e.origin !== name)]
            return [
                ...cleanErrors,
                ...errs
            ]
        })
    }, [])

    return (
        <form className=""> 
            <FormElement
                value={formFields.raison_refus}
                options={statusFilter}
                name="raison_refus"
                id="raison_refus"
                type="select"
                label={t("edit.select-reason", { ns: "partner" })}
                className="mb-5 pt-4"
                required={true}
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />

            <FormElement
                value={formFields.explication_refus}
                name="explication_refus"
                type="textarea"
                label={t("edit.add-info", { ns: "partner" })}
                className="pt-4"
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />
        </form>
    )
}
